@if (featureSection().items.length) {
  <app-menu-section
    [section]="featureSection()"
    [iconOnly]="iconOnly()"
    (itemSelect)="onOtherSectionSelect($event)"
  />
}

@if (gradeBoosterSection().items.length) {
  <app-menu-section
    [section]="gradeBoosterSection()"
    [iconOnly]="iconOnly()"
    [selectedId]="selectedGradeBoosterId"
    (itemSelect)="onGradeBoosterSelect($event)"
  />
}

@if (courseSection().items.length) {
  <app-menu-section
    [section]="courseSection()"
    [iconOnly]="iconOnly()"
    [selectedId]="selectedCourseId"
    (itemSelect)="onCourseSelect($event)"
  />
}

@if (campaignSection().items.length) {
  <app-menu-section
    [section]="campaignSection()"
    [iconOnly]="iconOnly()"
    (itemSelect)="onOtherSectionSelect($event)"
  />
}
